import { useState, useEffect } from "react";
import { API } from "../request/api";
import { useDispatch, useSelector } from "react-redux";
import { set_country, set_language } from "../store/actions/region_action";
import { BaseChannel } from '../base/env';
import { _set_store } from "../store/actions/login_actions";
import { DEFAULT_LANG } from '../i18n';

export function useIpLanguage({ urlResolved = false } = {}) {
  const [language, setLanguage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const { language: ipLanguage, country: ipCountry } = useSelector(
    (state) => state.Region,
  );
  const { channel, pendingChannel, country_id } = useSelector(
    (state) => state.Login,
  );


  // Default store: never block on pendingChannel (claim / no-flow URLs still need country/state).
  // If `pendingChannel` is set, it wins over IP for region (promo stays Oman; pending canada → Canada).
  useEffect(() => {
    if (!urlResolved) return;
    if (country_id) return;

    let isCanadaGeo;
    let isSaudiaGeo;

    if (pendingChannel) {
      isCanadaGeo = pendingChannel === 'canada';
      isSaudiaGeo = pendingChannel === 'saudi arabia';
    } else {
      isCanadaGeo = channel === 'canada' || (ipCountry && ipCountry.toLowerCase() === 'canada');
      isSaudiaGeo = channel === 'saudi arabia' || (ipCountry && ipCountry.toLowerCase() === 'saudi arabia');

    }

    if (isSaudiaGeo && !isCanadaGeo && !ipCountry && !pendingChannel) return;

    if (isCanadaGeo) {
      const keepCommittedChannel = pendingChannel === 'canada' && channel !== 'canada';
      dispatch(
        _set_store(
          1150,
          'Canada',
          keepCommittedChannel ? channel || BaseChannel : 'canada'
        )
      );
    }
    if (isSaudiaGeo) {
      const keepCommittedChannel = pendingChannel === 'saudi-channel' && channel !== 'saudi-channel';
      dispatch(
        _set_store(
          1289,
          'Saudi Arabia',
          keepCommittedChannel ? channel || BaseChannel : 'saudi-channel'
        )
      );
    }
    else {
      dispatch(_set_store(1, 'Oman', channel || BaseChannel));
    }
  }, [urlResolved, pendingChannel, ipCountry, country_id, channel, dispatch]);


  useEffect(() => {
    // Do not require `channel` here — it is always truthy in initial state and breaks the guard.
    if (ipLanguage && ipCountry) {
      setIsLoading(false);
      return;
    }

    let isMounted = true;


    API.get
      .languageIp()
      .then((response) => {
        if (!isMounted) return;

        const isoCode = response.data.country.iso_code;
        const country = response.data.country.names.en;

        // const isoCode = 'SA';

        // const country = 'Saudi Arabia';

        const detectedLang = countryToLangMap[isoCode];

        if (country) {
          dispatch(set_country(country));
        } else {
          console.log("FAILURE: 'country' is undefined or null.");
        }

        if (detectedLang) {
          setLanguage(detectedLang);
          dispatch(set_language(detectedLang));
        } else {
          console.log("FAILURE: 'detectedLang' is undefined or null.");
          if (isMounted) {
            setLanguage('en');
            dispatch(set_language('en'));
          }
        }
      })
      .catch((error) => {
        if (!isMounted) return;
        console.error('API call failed! Error:', error);
        dispatch(set_country('Oman'));
        dispatch(_set_store(1, 'Oman', channel || BaseChannel));
        setLanguage(DEFAULT_LANG);
        dispatch(set_language(DEFAULT_LANG));
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [urlResolved]);

  return { langFromIp: language, isLoading };
}


const countryToLangMap = {
  DZ: "ar", // Algeria
  BH: "ar", // Bahrain
  KM: "ar", // Comoros
  DJ: "ar", // Djibouti
  EG: "ar", // Egypt
  IQ: "ar", // Iraq
  JO: "ar", // Jordan
  KW: "ar", // Kuwait
  LB: "ar", // Lebanon
  LY: "ar", // Libya
  MR: "ar", // Mauritania
  MA: "ar", // Morocco
  OM: "ar", // Oman
  PS: "ar", // Palestine, State of
  QA: "ar", // Qatar
  SA: "ar", // Saudi Arabia
  SO: "ar", // Somalia
  SD: "ar", // Sudan
  SY: "ar", // Syrian Arab Republic
  TN: "ar", // Tunisia
  AE: "ar", // United Arab Emirates
  YE: "ar", // Yemen
  DE: "en",
};
